module.exports = __webpack_public_path__ + "img/spa_thumbnail-600x450.08639735.jpg";